import { Box, Typography } from '@mui/material';
import AgenticEmptyState from 'components/@home/@settings/Tabs/Agents/AgenticEmptyState';
import ImportIcon from 'mdi-react/ImportIcon';
import PlusCircleIcon from 'mdi-react/PlusCircleIcon';
import { bool, func } from 'prop-types';
import React from 'react';
import { I18n } from 'utils/i18n';

const AgentsEmptyState = ({ hasAgentic = false, onCreate, onImport }) => {
  const titleKey = hasAgentic ? 'AgenticChatFlow.AgentsTitle' : 'ChatFlowSettings.Flows';
  const subtitleKey = hasAgentic ? 'AgenticChatFlow.AgentsSubtitle' : 'ChatFlowSettings.Flows';
  const heroTitleKey = hasAgentic
    ? 'AgenticChatFlow.EmptyAgents.Title'
    : 'ChatFlowSettings.infoBox.title';
  const heroLeadKey = hasAgentic
    ? 'AgenticChatFlow.EmptyAgents.AgenticInfo'
    : 'AgenticChatFlow.EmptyAgents.PagesInfo';
  const primaryLabelKey = hasAgentic
    ? 'AgenticChatFlow.EmptyAgents.Cta'
    : 'ChatFlowSettings.Create flow';

  return (
    <Box
      sx={{
        flex: 1,
        display: 'flex',
        flexDirection: 'column',
        backgroundColor: 'background.paper',
        overflow: 'hidden',
      }}
    >
      <Box
        sx={{
          display: 'flex',
          alignItems: 'flex-end',
          gap: 2,
          p: '24px 32px 16px',
        }}
      >
        <Box sx={{ minWidth: 180 }}>
          <Typography variant="h5" sx={{ fontWeight: 600 }}>
            {I18n.t(titleKey)}
          </Typography>
          <Typography
            sx={{
              fontSize: theme => theme.typography.pxToRem(13),
              color: 'text.secondary',
              mt: 0.25,
            }}
          >
            {I18n.t(subtitleKey)}
          </Typography>
        </Box>
      </Box>

      <AgenticEmptyState
        concept="agent"
        title={I18n.t(heroTitleKey)}
        lead={I18n.t(heroLeadKey)}
        primaryLabel={I18n.t(primaryLabelKey)}
        primaryIcon={<PlusCircleIcon size={16} />}
        onPrimary={onCreate}
        secondaryLabel={I18n.t('AgenticChatFlow.ImportAgent')}
        secondaryIcon={<ImportIcon size={16} />}
        onSecondary={onImport}
        data-testid="agents-empty-state"
      />
    </Box>
  );
};

AgentsEmptyState.propTypes = {
  hasAgentic: bool,
  onCreate: func.isRequired,
  onImport: func.isRequired,
};

export default AgentsEmptyState;
